<template>
  <div id="app" ref="app" :class="{english: $route.params.lang==='EN'}">
    <Navigation></Navigation>
    <router-view/>
  </div>
</template>
<script>
import { isMobile } from '@/js/utils';
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'app',
  data() {
    return {
      timer: null
    }
  },
  mounted() {
    window.onbeforeunload = () => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
    if(!isMobile()) {
      window.onclick = (e) => {
        let div = document.createElement('div')
        div.className = 'little-plane'
        div.style.left = e.x + 'px'
        div.style.top = e.y - 10 + 'px'
        document.body.appendChild(div)
        setTimeout(() => {
          document.body.removeChild(div)
        }, 1000)
      }
    }
  },
  components: {    
		Navigation: () => import("@/components/header.vue"),
  },
  computed: {
    ...mapState(['headerStyle'])
  },
  watch: {
    $route(val) {
      if(val.path !== '/about') {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      }
    }
  },
  methods: {
    ...mapMutations(['setHeaderStyle'])
  }
}
</script>
<style lang="scss">
  @import "./assets/css/base.scss";
  @import "./assets/css/textFade.scss";
</style>
<style>
#app {
  /* font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji; */
  font-family: 'Microsoft Yahei', 'PingFang SC','HanHei SC', 'Helvetica Neue', 'Helvetica', 'STHeitiSC-Light', 'Arial', sans-serif; 
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  overflow-x: hidden;
}
.little-plane {
  position: fixed;
  width: 30px;
  height: 20px;
  background: url("../src/assets/image/plane.svg") no-repeat center;
  background-size: cover;
  animation: planeUp linear 800ms forwards;
  z-index: 3;
}
@keyframes planeUp {
  0% {
    opacity: 1;
    transform: translate(-50%,0)
  }
  100% {
     opacity: 0;
    transform: translate(-50%, -40px)
  }
}
</style>
<style lang="scss">
  @media screen and (min-width: 1441px){
    .english {
        h3.title.textfade {
          line-height: 52px;
        }
        .title+p.text {
          line-height: 25px;
          margin-top: 20px;
        }
        .section-2 .tips span {
          line-height: 25px;
        }
    }
  }
   @media screen and (max-width: 1440px){
    .english {
        h3.title.textfade {
          line-height: 40px;
        }
        .title+p.text {
          line-height: 25px;
          margin-top: 20px;
        }
        .section-2 .tips span {
          line-height: 25px;
        }
    }
  }

  @media screen and (max-width: 600px){
    .english {
        h3.title.textfade, h3.title, h4.title {
          margin: 0 auto;          
          letter-spacing: 0;
          line-height: 1.5rem;
        }
      .title+p.text {
        line-height: 1rem;
      }
    }
  }
</style>
